import { render, staticRenderFns } from "./UpgradeReportAlert.vue?vue&type=template&id=ec9608c4&"
import script from "./UpgradeReportAlert.vue?vue&type=script&lang=js&"
export * from "./UpgradeReportAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports